import React from 'react';
import { motion } from 'framer-motion';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import data from '../../data/contact';
import { fadeUp } from '../../utils/motion';

const ContactIcons = () => (
  <motion.ul className="icons" variants={fadeUp} initial="hidden" animate="visible">
    {data.map((s) => (
      <motion.li key={s.label} variants={fadeUp}>
        <a href={s.link} aria-label={s.label}>
          <FontAwesomeIcon icon={s.icon} />
        </a>
      </motion.li>
    ))}
  </motion.ul>
);

export default ContactIcons;
